export default __webpack_public_path__ + "static/media/user-ninja.028804c6.svg";